// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/spin/style/index.less
// module id = 1041
// module chunks = 1